import { createPortal } from 'react-dom';

import '@/styles/loaders/overlay.scss';
import type { ReactNode } from 'react';

export const GLOBAL_LOADER_ROOT_ID = 'global-loader-root';

type OverlayProps = {
  backdrop?: boolean;
  containerClass?: string;
  loadingAnimation?: () => ReactNode;
  text?: string;
  subtext?: string;
  /** When false, renders inline instead of via a portal. Use this when a parent component
   *  (e.g. AG Grid) controls visibility via CSS — portaled content escapes that control. */
  usePortal?: boolean;
};

export default function Overlay({
  backdrop = true,
  text,
  subtext = '',
  loadingAnimation,
  containerClass,
  usePortal = true,
}: OverlayProps) {
  const renderSpinner = () => {
    if (loadingAnimation) {
      return loadingAnimation();
    }

    return (
      <div className="loader-background">
        <div className="loader-segment light" />
        <div className="loader-segment medium" />
        <div className="loader-segment dark" />
      </div>
    );
  };

  const content = (
    <div className="global-loader">
      {backdrop && <div className="global-loader-backdrop" />}
      <div
        className={`loading-app default global-loader-body ${subtext ? 'loader-with-subtext' : ''} ${containerClass ?? ''}`}
      >
        {renderSpinner()}
        <span className="loader-text">{text ?? 'Loading...'}</span>
        {subtext && <p>{subtext}</p>}
      </div>
    </div>
  );

  if (!usePortal) {
    return content;
  }

  return createPortal(content, document.getElementById(GLOBAL_LOADER_ROOT_ID) as HTMLElement);
}
